import { supabase } from '../supabaseClient'

// Llama a la Edge Function send-email con la sesión del usuario (JWT). Desde
// A5 el servidor ignora los datos del body en los tipos de usuario: el
// destinatario y el contenido salen de la base (perfil y empresa de la
// sesión). Los errores se registran pero nunca se lanzan, para que un fallo
// de correo no corte el registro.
async function invokeEmailFunction(type: 'welcome' | 'admin_notification'): Promise<void> {
  const { error } = await supabase.functions.invoke('send-email', {
    body: { type },
  })
  if (error) console.error(`[email] ${type} failed:`, error)
}

// ── Public API ───────────────────────────────────────────────────────────────

// Bienvenida al correo de la sesión, con el nombre y la empresa de la base.
export async function sendWelcomeEmail(): Promise<void> {
  await invokeEmailFunction('welcome')
}

// Aviso interno de "nueva empresa registrada" (destinatario fijo en el servidor).
export async function sendAdminNotification(): Promise<void> {
  await invokeEmailFunction('admin_notification')
}
